export const PRICE_UNDETERMINED_LABEL = 'Pa përcaktuar';

export function isRidePriceDetermined(ride = {}) {
  if (ride.price_determined === false) return false;
  if (ride.price_source === 'unpriced') return false;
  const lek = ride.final_price ?? ride.price_lek ?? ride.estimated_price ?? ride.fare;
  return lek != null && Number(lek) > 0;
}

export function getRidePriceLek(ride = {}) {
  if (!isRidePriceDetermined(ride)) return null;
  return ride.final_price ?? ride.price_lek ?? ride.estimated_price ?? ride.fare ?? null;
}

export function formatRidePriceLek(ride = {}, { undeterminedLabel = PRICE_UNDETERMINED_LABEL } = {}) {
  const lek = getRidePriceLek(ride);
  if (lek == null) return undeterminedLabel;
  return `${Number(lek).toLocaleString()} L`;
}
